import { GAME_UPDATE, FETCH_EVENTS_ERROR, EVENTS_UPDATE, EVENT_UPDATE, GAME_SET_QUESTION, GAME_USER_SELECT_ANSWER, GAME_USER_UPDATE, GAME_SET_SCREEN, GAME_SET_TIME_TO_OPENING_CREDITS, GAME_ON_QUESTION_COMPLETE, EVENTS_SET_ACTIVE, FETCH_EVENTS_SUCCESS, FETCH_EVENTS_LOADING, FETCH_EVENT_LOADING, FETCH_EVENT_ERROR, FETCH_EVENT_SUCCESS, FETCH_EVENT_DETAILS_BETS, FETCH_EVENT_DETAILS_BETS_SUCCESS, FETCH_EVENT_DETAILS_BETS_ERROR, FETCH_EVENT_DETAILS_BETS_LOADING } from '../constants/action-types';
const initialState = {
    events: [],
    eventsBets: [],
    eventsBetsLoading: false,
    eventsBetsError: null,
    loading: false,
    error: null
};


const eventsReducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_EVENT_DETAILS_BETS_SUCCESS: {
            return Object.assign({},
                state,
                {
                    eventsBets: action.payload,
                    eventsBetsLoading: false,
                    eventsBetsError: null
                })
        }
        // case FETCH_EVENTS_UPDATE: {

        // }
        // TODO
        case FETCH_EVENT_DETAILS_BETS_LOADING: {
            return Object.assign({},
            state)
        }
        // TODO
        case FETCH_EVENT_DETAILS_BETS_ERROR: {
            return Object.assign({},
            state)
        }
        case FETCH_EVENT_SUCCESS:
        case FETCH_EVENTS_SUCCESS: {
            return Object.assign({},
                state,
                {
                    events: action.payload,
                    loading: false,
                    error: null
                })
        }
        case FETCH_EVENT_LOADING:
        case FETCH_EVENTS_LOADING: {
            return Object.assign({},
                state,
                {
                    loading: true
                })
        }
        case FETCH_EVENT_ERROR:
        case FETCH_EVENTS_ERROR: {
            return Object.assign({},
                state,
                {
                    error: action.payload
                })
        }
        default: return state
    }
};

export default eventsReducer


// WEBPACK FOOTER //
// ./src/reducers/event-reducer.js